import React, { FC, useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Menubar as PrimeReactMenuBar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import { VpdThreshold } from 'models/restTypes';
import VpdThresholdEditDialog from './VpdThresholdEditDialog';

const StyledPrimeReactMenuBar = styled(PrimeReactMenuBar)`
  .p-submenu-list {
    width: auto;
  }

  .p-menuitem-text {
    text-wrap: nowrap;
  }
`;

interface MenuBarProps {
  selectedThreshold: VpdThreshold | null;
  onThresholdUpdated: (threshold: VpdThreshold) => void;
}

const MenuBar: FC<MenuBarProps> = ({
  selectedThreshold,
  onThresholdUpdated,
}) => {
  const { t } = useTranslation('thresholds');

  const [editDialog, setEditDialog] = useState(false);

  const openEditDialog = useCallback(() => {
    setEditDialog(true);
  }, []);

  const closeEditDialog = useCallback(() => {
    setEditDialog(false);
  }, []);

  const menuItems: MenuItem[] = useMemo(
    () => [
      {
        label: t('edit'),
        icon: 'pi pi-fw pi-pencil',
        disabled: !selectedThreshold,
        command: () => {
          openEditDialog();
        },
      },
    ],
    [t, selectedThreshold, openEditDialog],
  );

  return (
    <div
      style={{ width: '100%', display: 'flex', justifyContent: 'flex-start' }}
    >
      <StyledPrimeReactMenuBar model={menuItems} />
      {editDialog && selectedThreshold && (
        <VpdThresholdEditDialog
          visible={editDialog}
          onHide={closeEditDialog}
          threshold={selectedThreshold}
          onUpdated={onThresholdUpdated}
        />
      )}
    </div>
  );
};

export default observer(MenuBar);
